export default theme => ({
  editRoot: {
    padding: theme.spacing(0),
    position: "absolute",
    minWidth: "100%",
    minHeight: "calc(100% - 67px)",
    left: "0px",
    top: "67px"
  },
  editLeftSide: {
    position: "absolute",
    minWidth: "calc(100% - 559px)",
    minHeight: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)"
  },
  editRightSide: {
    width: "559px",
    left: "calc(100% - 559px)",
    position: "absolute",
    minHeight: "100%",
    boxShadow: "-2px 2px 4px 0 rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column"
  },
  editCloseContainer: {
    display: "flex"
  },
  editCloseButton: {
    marginLeft: "auto",
    order: "2"
  },
  connectorTitle: {
    textTransform: "uppercase",
    color: theme.palette.text.secondary
  },
  editTitleRow: {
    display: "flex",
    flexDirection: "row"
  }
});
